import ReactLoading from "react-loading";

export default function Loading() {

  return (
    <>
        <ReactLoading
          type={"bars"}
          color={"#9F8A58"}
          height={100}
          width={100}
        />
     
    </>
  );
}
